// This file is auto-generated by scripts/set-env.js
export const environmentVariables = {
    environmentId: '90ccae62-fd26-4bf7-acda-8f99f9d98729',
    approvalWorkflowApiKey: 'awk_rbi_fxLenW8kfNdeh3xy4taKMgphOFnLuWKDmfe0j0RQExI',
    sblCoreApiKey: '7A3F91D6C82B4E05F1A9D37C6E8B204F',
    orderEvaluationApiKey: 'abc123',
    sfmcApiKey: 'tcFoIjKfGSLd-BGK5YPjvgGYm1VYhY5HkrTczuOAr8c',
    vitaminsApiKey: '2E9A7C40FB1D68E3AC75F42D093BEC1F',
};
